<template>
    <div class="invite-container">
        <div class="regis-info">
            <p>
                <span class="first-line"><img src="../assets/purelogo.png" /> wowotown！窝窝投</span>
            </p>
            <p><span class="third-line">邀请好友</span></p>
            <p><span class="second-line">海量任务 超多福利</span></p>
        </div>
        <div>
            <div class="button-wrapper" v-if="promotionCode">
                <van-button class="face-invite" round icon="qr" @click="renderCode">面对面邀请</van-button>
                <van-button class="instance-invite" round @click="sendMessage">立即邀请</van-button>
            </div>
            <div class="invite-history">
                <p>历史邀请人数：{{ total }}人</p>
                <div>
                    <van-row>
                        <van-col span="8">手机号</van-col>
                        <van-col span="8">实名认证</van-col>
                        <van-col span="8">下载APP</van-col>
                    </van-row>
                    <van-row class="list-row" v-for="item in inviteData" :key="item.id">
                        <van-col span="8">{{
                            item.phone | phoneFormat
                            }}</van-col>
                        <van-col span="8">{{
                            item.identityAuthFlag && item.identityAuthFlag.desc
                            }}</van-col>
                        <van-col span="8">{{
                            item.appVersion === "0" ? "未下载" : "已下载"
                            }}</van-col>
                    </van-row>
                    <div class="show-more">
                        <span v-if="total === 0">暂无更多</span>
                        <span v-if="!nomore" @click="showMore">查看更多></span>
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="show">
            <div style="padding: 10px">
                <div class="qrcode" ref="qrCodeUrl"></div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import QRCode from "qrcodejs2";
import { fetchInviteList, fetchDetail } from "../services/users";
import { Toast } from "vant";
import Cookies from "js-cookie";

export default {
    data() {
        return {
            inviteData: [],
            params: {
                current: 1,
                size: 10,
            },
            total: 0,
            nomore: false,
            promotionCode: "",
            show: false,
            qrcode: null,
        };
    },
    filters: {
        phoneFormat(text) {
            return text.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
        },
    },
    mounted() {
        // Cookies.set('token', 'b505462053864dcaa089e76e6b9b5516_app')
        Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "加载中",
        });
        Cookies.set("token", "839c18ad93ce410a886d7b2900927526_app");
        Cookies.set("secretKey", "d330a946b53d4b30a96303a5aad72475");
        this.checkToRequest();
    },
    methods: {
        checkToRequest() {
            let checkCount = 0;
            const timer = setInterval(async () => {
                const token = Cookies.get("token") || "";
                checkCount++;
                if (token) {
                    clearInterval(timer);
                    this.getInviteList();
                    fetchDetail().then((res) => {
                        this.promotionCode = res.data.promotionCode;
                    });
                    Toast.clear();
                } else {
                    if (checkCount > 10) {
                        Toast.clear();
                        Toast({
                            message: "系统异常，请稍后再试",
                            position: "bottom",
                        });
                        clearInterval(timer);
                    }
                }
            }, 500);
        },
        renderCode() {
            this.show = true;
            if (this.qrcode === null) {
                const that = this;
                this.$nextTick(() => {
                    const host = "https://apph5web.wowotown.com";
                    const value = `${host}/inviteRegis?code=${this.promotionCode}`;
                    this.qrcode = new QRCode(that.$refs.qrCodeUrl, {
                        text: value, // 需要转换为二维码的内容
                        width: 150,
                        height: 150,
                        colorDark: "#000000",
                        colorLight: "#ffffff",
                        correctLevel: QRCode.CorrectLevel.H,
                    });
                });
            }
        },
        showMore() {
            this.params.current += 1;
            this.getInviteList();
        },
        getInviteList() {
            fetchInviteList(this.params).then((res) => {
                this.total = res.data.total;
                if (this.params.current === 1) {
                    this.inviteData = res.data.records;
                } else {
                    this.inviteData = this.inviteData.concat(res.data.records);
                }
                if (this.inviteData.length >= res.data.total) {
                    this.nomore = true;
                }
            });
        },
        sendMessage() {
            const title = "招募吃喝玩乐体验官";
            const description =
                "wowotown为您提供全国试吃试喝试玩体验，注册后立即成为我们的体验官";
            // const title = '来Waaoh，开双旦节万元盲盒，开启整年好运！'
            // const description = '下载Waaoh APP，参加双旦活动：2份万元锦鲤大礼包、海量礼品，千份现金任务，TOP10拉新王更有额外豪礼！'
            const url = `inviteRegis?code=${this.promotionCode}`;
            // eslint-disable-next-line no-undef
            // jsBridgeForShare.postMessage(`${title}|${description}|${url}`);

            if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
                window.flutter_inappwebview
                    .callHandler("jsBridgeForShare", {info: `${title}|${description}|${url}`})
                    .then((result) => {
                        console.log("Flutter返回:", result);
                    })
                    .catch((err) => {
                        console.error("调用失败:", err);
                        jsBridgeForShare.postMessage(`${title}|${description}|${url}`);
                    });
            } else {
                jsBridgeForShare.postMessage(`${title}|${description}|${url}`);
            }

        },
    },
};
</script>

<style lang="less" scoped>
.button-wrapper {
    display: flex;
    padding: 0 15px;
    justify-content: space-between;

    .van-button {
        height: 40px;
        font-size: 22px;
        letter-spacing: 1px;
        padding: 0;
        width: 166px;

        &.face-invite {
            color: #f93b36;
            background: rgba(255, 255, 255, 0.8);
            border: 1px solid rgba(254, 108, 96, 1);
            //border-image: linear-gradient(180deg, rgba(254, 108, 96, 1), rgba(247, 41, 35, 1)) 1 1;
        }

        &.instance-invite {
            background: linear-gradient(180deg, #ff6864 0%, #f82923 100%);
            color: white;
            border-color: #ff6864;
        }
    }
}

.invite-container {
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    position: absolute;
    height: 100%;
    background-size: 100%;
    background: url(../assets/inviteRR.png) top left/100% 100% no-repeat;
    width: 375px;

    .regis-info {
        min-height: calc(100vh - 300px);
        padding: 20px 15px;
        background-size: 170%;
        background-position: center;

        p {
            margin: 0;

            span {
                display: inline-block;
                font-size: 27px;
                letter-spacing: 2px;
                font-family: PingFang-SC-Heavy, PingFang-SC;
                color: #ffffff;
                line-height: 48px;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
                -webkit-text-stroke: 0 #ffffff;
                text-stroke: 0px #ffffff;

                &.first-line {
                    font-family: PingFang-SC-Bold;
                    margin-top: 8px;
                    display: block;
                    text-align: center;
                    font-size: 18px;

                    img {
                        position: relative;
                        top: 3px;
                        width: 25px;
                        height: 18px;
                    }
                }

                &.second-line {
                    font-weight: 600;
                    margin-top: 20px;
                    text-align: center;
                    width: 100%;
                    height: 42px;
                    line-height: 42px;
                    display: block;
                    overflow-wrap: break-word;
                    white-space: nowrap;
                    font-size: 40px;
                    color: rgba(255, 255, 255, 1);
                    box-sizing: border-box;
                }

                &.third-line {
                    color: #ffffff;
                    line-height: 20px;
                    width: 100%;
                    height: 42px;
                    display: block;
                    font-size: 42px;
                    line-height: 42px;
                    text-align: center;
                    box-sizing: border-box;
                    font-weight: 600;
                    margin-top: 10px;
                }

                &.img-position {
                    position: absolute;
                    left: 15px;
                    top: 177px;
                    width: 344px;
                    height: 283px;
                }

                &.gift-position {
                    position: absolute;
                    left: 284px;
                    top: 300px;
                    width: 56px;
                    height: 56px;
                }
            }
        }
    }

    .invite-history {
        padding: 20px 15px;
        background: url(../assets/inviteHistory.png) -1px 0px no-repeat;
        border-radius: 8px;
        font-size: 13px;
        color: #000;
        background-size: 170%;
        margin: 25px 10px;

        .list-row {
            .van-col {
                font-size: 12px;
            }

            color: #666;
        }

        p {
            font-size: 13px;
            padding-left: 10px;
            line-height: 40px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.4);
        }

        .van-col {
            text-align: center;
            line-height: 30px;
        }

        .show-more {
            text-align: center;

            span {
                padding: 5px 0;
            }
        }
    }
}
</style>
